import backend, {SCHEDULE_API} from 'utils/backend/server/api_library';

import queryString from 'query-string';

const loadEvent = (eventRn, loadClientData, loadCaregiverData, loadClientCareviewData, loadCaregiverUpdates) => {
  const queryParam = {
    loadClientData,
    loadCaregiverData,
    loadClientCareviewData,
    loadCaregiverUpdates,
  };
  const query = queryString.stringify(queryParam, {skipNull: true, skipEmptyString: true});

  return backend.get(`${SCHEDULE_API}/schedule/${eventRn}?${query}`);
};

const createEventUpdate = (eventRn, type, data) => {
  const body = {
    type,
    data,
  };
  const url = `${SCHEDULE_API}/schedule/${eventRn}/event_update`;
  return backend.post(url, body);
};

const updateAllEventInfo = (clientRn, recurrenceRn, info, shiftType) => {
  const body = {
    info,
    shiftType,
  };
  const url = `${SCHEDULE_API}/schedule/client/${clientRn}/recurrence/${recurrenceRn}/update_event_info`;
  return backend.put(url, body);
};

const cancelEvent = (clientRn, eventRn, reasonForException) => {
  const body = {
    reasonForException,
  };
  const url = `${SCHEDULE_API}/schedule/client/${clientRn}/event/${eventRn}/cancel`;
  return backend.put(url, body);
};

const rescheduleEvent = (clientRn, eventRn, reasonForException, eventData, shiftType) => {
  const body = {
    reasonForException,
    eventData,
    shiftType,
  };
  const url = `${SCHEDULE_API}/schedule/client/${clientRn}/event/${eventRn}/reschedule`;
  return backend.put(url, body);
};

const updateEventCaregiver = (clientRn, eventRn, caregiverData, reasonForException) => {
  const body = {
    caregiverData,
    reasonForException,
  };
  const url = `${SCHEDULE_API}/schedule/client/${clientRn}/event/${eventRn}/update_caregiver`;
  return backend.put(url, body);
};

const updateEventInfo = (clientRn, eventRn, info, shiftType) => {
  const body = {
    info,
    shiftType,
  };
  const url = `${SCHEDULE_API}/schedule/client/${clientRn}/event/${eventRn}/update_event_info`;
  return backend.put(url, body);
};

const updateShiftType = (clientRn, eventRn, shiftType) => {
  const body = {
    shiftType,
  };
  const url = `${SCHEDULE_API}/schedule/client/${clientRn}/event/${eventRn}/shift_type`;
  return backend.put(url, body);
};

const declineEvent = (eventRn, type, adminAction) => {
  const body = {
    type,
    adminAction,
  };
  const url = `${SCHEDULE_API}/schedule/${eventRn}/event_update/admin_action`;
  return backend.post(url, body);
};

export default {
  loadEvent,
  createEventUpdate,
  cancelEvent,
  rescheduleEvent,
  updateEventInfo,
  updateAllEventInfo,
  updateShiftType,
  updateEventCaregiver,
  declineEvent,
};
